// Medical Cases Selectors

const selectMedicalCasesState = (state) =>
  state?.medicalCases || state?.medicalcase || state?.medicalCase || {};

// ========== CASES ==========

export const selectMyUnpublishedCases = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.casesList?.my?.items || [];
};

export const selectMyUnpublishedCasesStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.casesList?.my?.status || "idle";
};

export const selectMyUnpublishedCasesError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.casesList?.my?.error || null;
};

export const selectPublicCases = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.casesList?.public?.items || [];
};

export const selectPublicCasesStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.casesList?.public?.status || "idle";
};

export const selectPublicCasesError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.casesList?.public?.error || null;
};

export const selectCurrentCase = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.currentCase?.data || null;
};

export const selectCurrentCaseStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.currentCase?.status || "idle";
};

export const selectCurrentCaseError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.currentCase?.error || null;
};

export const selectCaseById = (state, caseId) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.casesById?.[caseId] || null;
};

// ========== ATTACHMENTS ==========

export const selectAttachmentStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.attachmentStatus || "idle";
};

export const selectAttachmentError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.attachmentError || null;
};

// ========== ANNOTATIONS ==========
// Annotations are stored per (caseId, attachmentId) pair — a case can have
// several attachments and each one has its own independent annotation list.

export const selectAnnotationsByCaseAndAttachment = (
  state,
  caseId,
  attachmentId
) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.annotations?.[`${caseId}:${attachmentId}`] || [];
};

export const selectAnnotationsStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.annotationsStatus || "idle";
};

export const selectAnnotationsError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.annotationsError || null;
};

// ========== LIKES ==========

export const selectLikesByCaseId = (state, caseId) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.likesById?.[caseId] || null;
};

export const selectLikesStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.likesStatus || "idle";
};

export const selectLikesError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.likesError || null;
};

// ========== COMMENTS ==========

export const selectCommentsByCaseId = (state, caseId) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.commentsByCaseId?.[caseId] || [];
};

export const selectCommentsStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.commentsStatus || "idle";
};

export const selectCommentsError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.commentsError || null;
};

// ========== LIVES ==========

export const selectMyLives = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.livesList?.my?.items || [];
};

export const selectMyLivesStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.livesList?.my?.status || "idle";
};

export const selectMyLivesError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.livesList?.my?.error || null;
};

export const selectPublicLives = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.livesList?.public?.items || [];
};

export const selectPublicLivesStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.livesList?.public?.status || "idle";
};

export const selectPublicLivesError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.livesList?.public?.error || null;
};

export const selectCurrentLive = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.currentLive?.data || null;
};

export const selectCurrentLiveStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.currentLive?.status || "idle";
};

export const selectCurrentLiveError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.currentLive?.error || null;
};

export const selectLiveById = (state, liveId) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.livesById?.[liveId] || null;
};

export const selectLiveConnection = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.liveConnection || null;
};

export const selectLiveParticipantsById = (state, liveId) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.liveParticipantsById?.[liveId] || [];
};

export const selectLiveParticipantsStatusById = (state, liveId) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.liveParticipantsStatusById?.[liveId] || "idle";
};

export const selectLiveCommentsById = (state, liveId) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.liveCommentsById?.[liveId] || [];
};

export const selectLiveCommentsStatus = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.liveCommentsStatus || "idle";
};

export const selectLiveCommentsError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.liveCommentsError || null;
};

// ========== GENERAL ==========

export const selectError = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.error || null;
};

export const selectSuccessMessage = (state) => {
  const medicalCases = selectMedicalCasesState(state);
  return medicalCases?.successMessage || null;
};
